<udex-footer
  id='udex-footer'
  logo-title="SAP"
  logo-aria-label="SAP"
  logo-link='https://www.sap.com'
  logo-url='https://cdn.udex.services.sap.com/dds/design-tokens/assets/logos/sap-logo.svg'
  logo-alt='SAP Logo'

  [attr.quick-links]='quickLinksData | json'
  [attr.trending-links]='trendingLinksData | json'
  [attr.about-links]= 'aboutSapLinksData | json'
  [attr.site-information-links]= 'siteInformationLinksData | json'
  [attr.social-links]='socialMediaData | json'>
</udex-footer>
